(() => {
  const CLOSE_ICON = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="rgba(0, 0, 0, 1)" viewBox="0 0 256 256"><path d="M208.49,191.51a12,12,0,0,1-17,17L128,145,64.49,208.49a12,12,0,0,1-17-17L111,128,47.51,64.49a12,12,0,0,1,17-17L128,111l63.51-63.52a12,12,0,0,1,17,17L145,128Z"></path></svg>`;

  let currentOverlay = null;
  let previousBodyOverflow = '';

  function close() {
    if (!currentOverlay) return;
    currentOverlay.remove();
    currentOverlay = null;
    document.body.style.overflow = previousBodyOverflow;
    document.removeEventListener('keydown', onKeydown);
  }

  function onKeydown(e) {
    if (e.key === 'Escape') close();
  }

  function open(sourceImg, trigger) {
    if (currentOverlay) close();

    const instantScope = trigger.closest('.__instant');
    if (!instantScope) return;

    const overlay = document.createElement('div');
    overlay.className = 'instant-overlay instant-overlay--lightbox purelei-lightbox';
    overlay.dataset.state = 'open';
    overlay.style.zIndex = '1000';

    const img = sourceImg.cloneNode();
    img.removeAttribute('id');
    img.sizes = '100vw';
    img.style.objectFit = 'contain';
    img.loading = 'eager';
    img.setAttribute('fetchpriority', 'high');
    overlay.appendChild(img);

    const closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'instant-overlay--lightbox__button-close';
    closeBtn.setAttribute('aria-label', 'Close lightbox');
    closeBtn.innerHTML = CLOSE_ICON;
    closeBtn.addEventListener('click', close);
    overlay.appendChild(closeBtn);

    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) close();
    });

    previousBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    instantScope.appendChild(overlay);
    document.addEventListener('keydown', onKeydown);
    currentOverlay = overlay;
  }

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('.purelei-lightbox-trigger');
    if (!trigger) return;
    const imgId = trigger.dataset.pureleiLightboxImageId;
    if (!imgId) return;
    const sourceImg = document.getElementById(imgId);
    if (!sourceImg) return;
    e.preventDefault();
    open(sourceImg, trigger);
  });
})();
